import React from "react";
type SectionHeadingProps = {
  kicker?: string;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  tone?: "light" | "dark";
};
export function SectionHeading({
  kicker,
  title,
  subtitle,
  tone = "light"
}: SectionHeadingProps) {
  const dark = tone === "dark";
  return <div className="mx-auto max-w-3xl text-center" data-id="element-68" data-mp="3k06sdhx8u5sg">
      {kicker && <p className={`text-sm font-bold uppercase tracking-wider ${dark ? "text-[#F2B79F]" : "text-coral"}`} data-id="element-69" data-mp="3k29l49ps6d0v">{kicker}</p>}
      <h2 className={`mt-3 font-serif text-[2rem] font-extrabold leading-[1.12] sm:text-5xl ${dark ? "text-cream" : "text-ink"}`} data-id="element-70" data-mp="gj6sh4dhx1fs">
        {title}
      </h2>
      {subtitle && <p className={`mt-4 text-lg leading-relaxed sm:text-xl ${dark ? "text-cream/80" : "text-ink/75"}`} data-id="element-71" data-mp="1sprfm4rwdjf">{subtitle}</p>}
    </div>;
}